import * as React from 'react';
import { SVGProps } from 'react';

const IconArtBrushSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.44 10.609c-.466-.466-1.248-.64-1.962-.34-.631.285-1.046.835-1.197 1.576-.224 1.104-.363 1.981-.781 2.655 1.276.091 3.07-.393 4.063-1.306.61-.567.596-1.866-.123-2.585zm8.543-8.614C13.19 1.203 9 5 7 7c-.747.747-1.984 2.208-1.984 2.208.362.102.84.378 1.125.663.293.286.572.775.678 1.156 0 0 1.44-1.286 2.181-2.027 2-2 5.777-6.212 4.983-7.005z" />
  </svg>
);
export default IconArtBrushSizeS;
